import { VehicleType } from '../types';

export const VEHICLE_TYPES: VehicleType[] = [
  { value: '1', label: 'Xe ô tô', icon: 'airport_shuttle' },
  { value: '2', label: 'Xe máy', icon: 'two_wheeler' },
  { value: '3', label: 'Xe máy điện', icon: 'electric_bike' },
];
